import CardContainer from './CardContainer';
import SideDrawer from './SideDrawer';
import { useNavigate } from 'react-router-dom';
import { NAVIGATION_LINKS_DATA } from '../../constants';
import useCategoryUploadState from '../hooks/useCategoryUploadState';
import InsufficientData from './InsufficientData';
import CustomButton from '../reusable/CustomButton';
import GoBackIcon from '../assets/transcript-selection-arrow-left.svg';
import useExternalSchoolCheck from './hooks/useExternalSchoolCheck';

import './DataQcContentContainer.css';

interface DataQcContentContainerProps {
  drawerTitle: string;
  drawerContent: React.ReactNode;
  cardTitle: string;
  cardContent: React.ReactNode;
  description: string;
  sideDrawerDivider?: boolean;
  categoryName: string;
  categoryId: string;
}

const DataQcContentContainer = ({
  cardContent,
  drawerContent,
  drawerTitle,
  cardTitle,
  description,
  sideDrawerDivider = true,
  categoryName,
  categoryId,
}: DataQcContentContainerProps) => {
  const navigate = useNavigate();
  const shouldShowExternalMessage = useExternalSchoolCheck();
  const isCourseCatalogs = drawerTitle === 'Course catalogs summary';

  const hasSufficientData = useCategoryUploadState(categoryName);
  if (!hasSufficientData) return <InsufficientData category={categoryName} categoryId={categoryId} />;

  const shouldShowDrawer = !shouldShowExternalMessage || isCourseCatalogs;

  return (
    <div className="data-qc-details-container">
      <div className="main-content">
        <CustomButton
          variant="text"
          buttonText="Back"
          icon={<img src={GoBackIcon} alt="go back" />}
          iconPosition="start"
          buttonAction={() => navigate(NAVIGATION_LINKS_DATA.DATA_QC.path)}
        />
        <CardContainer title={cardTitle} classes={['data-qc-card-container']}>
          {cardContent}
        </CardContainer>
      </div>
      {shouldShowDrawer && (
        <SideDrawer
          title={drawerTitle}
          description={description}
          classes={['data-qc-drawer-container']}
          handleClose={() => navigate(NAVIGATION_LINKS_DATA.DATA_QC.path)}
          isOpen={true}
          divider={sideDrawerDivider}
        >
          {drawerContent}
        </SideDrawer>
      )}
    </div>
  );
};

export default DataQcContentContainer;
